import { render, staticRenderFns } from "./ConsultBanner3.vue?vue&type=template&id=af24dd4c&"
import script from "./ConsultBanner3.vue?vue&type=script&lang=js&"
export * from "./ConsultBanner3.vue?vue&type=script&lang=js&"
import style0 from "./ConsultBanner3.vue?vue&type=style&index=0&id=af24dd4c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports